import { render, staticRenderFns } from "./coupon-detail.vue?vue&type=template&id=f9761982&scoped=true&"
import script from "./coupon-detail.vue?vue&type=script&lang=js&"
export * from "./coupon-detail.vue?vue&type=script&lang=js&"
import style0 from "./coupon-detail.vue?vue&type=style&index=0&id=f9761982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9761982",
  null
  
)

export default component.exports